// HOME PAGE
export const tiles = document.querySelector(".tiles-home");

// SPECIFIC RECIPE PAGE
export const pageTitle = document.querySelector("title");
export const mainTitle = document.querySelector(".main-title");
export const mainImage = document.querySelector(".main-image");

export const ingredientsList = document.querySelector(".ingredients__list");
export const statsTime = document.querySelector(".stats__time");
export const statsServings = document.querySelector(".stats__servings");

export const prparation = document.querySelector(".preparation");
export const preparationTitle = document.querySelector(".preparation__title");
export const preparationDescription = document.querySelector(
  ".preparation__description"
);
export const preparationName = document.querySelector(".preparation__name");
export const preparationLink = document.querySelector(".preparation__link");

export const facebookShare = document.querySelector(".facebok-share");

// ALL RECIPE PAGE
export const allRecipeTiles = document.querySelector(".tiles--all-recipe");
export const tilesAll = document.querySelector(".tiles-all");

export const LoadMoreBTN = document.querySelector(".btn--load-more");
export const GroupRecipesBTN = document.querySelector(".btn--group");

export const form = document.querySelector(".recipe-form");
export const formInput = document.querySelector(".recipe-form__input");
export const formSumbmit = document.querySelector(".recipe-form__search");

// CREATE NEW RECIPE PAGE
export const submitForm = document.querySelector(".submit-recipe__form");
export const submitName = document.querySelector(".submit-name");
export const submitLast = document.querySelector(".submit-last-item");
export const submitSection = document.querySelector(".submit-recipe");
